import { render, staticRenderFns } from "./robotWeChatList.vue?vue&type=template&id=53dc5ca2&scoped=true&"
import script from "./robotWeChatList.vue?vue&type=script&lang=js&"
export * from "./robotWeChatList.vue?vue&type=script&lang=js&"
import style0 from "./robotWeChatList.vue?vue&type=style&index=0&id=53dc5ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dc5ca2",
  null
  
)

component.options.__file = "robotWeChatList.vue"
export default component.exports